import React from "react";
import { TouchableOpacity } from "react-native";
import { PaddingProps } from "@sloth-system/props";

import { Box, Typography, Stack, Spacer } from "digiwash-components";
import CircleCheckmark from "../CircleCheckmark";
import { color } from "@sloth-system/styled-utils";
import styled from "styled-components/native";

interface PropsType extends PaddingProps {
  title: string;
  sub?: string;
  desc?: string;
  onPress?: (...args: any) => void;
  // Types
  disabled?: boolean;
  selected?: boolean;
  readonly?: boolean;
  textColor?: string;
  subTextColor?: string;
}

let Container = styled(Box)`
  border: 1px solid ${color("gray.lighter")};
`;

function SelectableCard(props: PropsType) {
  let {
    selected,
    disabled,
    readonly,
    title,
    sub,
    desc,
    onPress,
    textColor,
    subTextColor,
    ...spaceProps
  } = props;

  let cardBg = "common.white";
  let color = selected ? "primary.main" : "common.black";
  let subColor = selected ? "green.main" : "red.main";
  let handler = disabled || readonly ? undefined : onPress;

  return (
    <Container
      p="m"
      br="m"
      bg={cardBg}
      {...spaceProps}
      // @ts-ignore
      onPress={handler}
      as={!disabled ? TouchableOpacity : null}
      style={{}}
    >
      <Stack distribution="space-between">
        <Stack>
          {!readonly && (
            <>
              <CircleCheckmark isSelected={selected} />
              <Spacer size="m" />
            </>
          )}
          <Typography color={textColor ? textColor : color}>{title}</Typography>
        </Stack>
        {sub && (
          <Typography
            ff="mainBold"
            fs="s"
            color={subTextColor ? subTextColor : subColor}
          >
            {sub}
          </Typography>
        )}
      </Stack>
      {desc && (
        <Box pt="m">
          <Typography ff="mainBold" fs="s" alignment="center" color="text.hint">
            {desc}
          </Typography>
        </Box>
      )}
    </Container>
  );
}

export default SelectableCard;
